import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IGetUserRefreshTokenCountParams {
  username: string;
  domainName: string;
}

export interface IGetUserRefreshTokenCountResult extends IResult {
  refreshTokenCount: number;
}

export class GetUserRefreshTokenCountRequest extends Request<IGetUserRefreshTokenCountParams, IGetUserRefreshTokenCountResult> {
  constructor(params: IGetUserRefreshTokenCountParams) {
    super('getUserRefreshTokenCount', params);
  }
}
